import { useEffect, useState } from "react";
import { fetchContent } from "@/lib/api";
import { FadeUp } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { KanthaStitch } from "@/components/Motifs";

const CATEGORIES = [
  "Fashion commissions",
  "Artwork commissions",
  "Editorial collaborations",
  "Brand collaborations",
  "Exhibitions",
  "Workshops",
  "Press",
  "General enquiries",
];

export default function Contact() {
  const [c, setC] = useState({});

  useEffect(() => {
    fetchContent("/content").then(setC);
  }, []);

  return (
    <main data-testid="contact-page" className="pt-24">
      <section className="max-w-[1500px] mx-auto px-5 md:px-10 pt-10 md:pt-16 pb-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-14">
          <div className="md:col-span-5">
            <FadeUp>
              <p className="text-[11px] tracking-[0.3em] uppercase text-alta mb-6">Contact</p>
              <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.08]">
                Let's Create Something Meaningful
              </h1>
              <p className="mt-8 text-base font-light text-ink/65 leading-relaxed max-w-md">
                {c.contact_note || "Every enquiry is read personally. Expect a reply within three working days."}
              </p>

              <KanthaStitch className="my-10" />

              <p className="text-[10px] tracking-[0.3em] uppercase text-ink/45 mb-5">Ways to work together</p>
              <ul className="space-y-3">
                {CATEGORIES.slice(0, 7).map((cat) => (
                  <li key={cat} className="flex items-center gap-3 text-sm font-light text-ink/70">
                    <span className="w-1.5 h-1.5 rounded-full bg-alta/70 shrink-0" />
                    {cat}
                  </li>
                ))}
              </ul>

              <div className="mt-10 space-y-2">
                <a href={`mailto:${c.social_email || "studio@ipsita.in"}`} data-testid="contact-email-link" className="link-underline block font-serif text-2xl text-ink">
                  {c.social_email || "studio@ipsita.in"}
                </a>
                <p className="text-sm font-light text-ink/50">Studio — Kolkata, West Bengal</p>
              </div>
            </FadeUp>
          </div>

          <div className="md:col-span-7">
            <FadeUp delay={0.15}>
              <EnquiryForm types={CATEGORIES} defaultType="General enquiries" testidPrefix="contact" />
            </FadeUp>
          </div>
        </div>
      </section>
    </main>
  );
}
